import { BasicCommand } from "./BasicCommand";
import { BasicController } from "../BasicController";
import { BasicSmartfoxConstants } from "../BasicSmartfoxConstants";
import { BasicModel } from "../../model/BasicModel";
import { CommandController } from './../../../commanding/CommandController';
import { Localize } from "@goodgamestudios/localization";
import { warn } from "../../../logging/warn";

export class CMTCommand extends BasicCommand {
    public static TEASERTYPE_EVENT: number = 0;
    public static TEASERTYPE_INFO: number = 1;
    public static TEASERTYPE_WARNING: number = 2;
    public static TEASER_TYPE_TEXT_ID: any[] = ["cm_teaserevent_title", "cm_teaserinfo_title", "cm_teaserwarning_title"];

    protected get cmdId(): string {
        return BasicSmartfoxConstants.S2C_COMA_TEASER;
    }

    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            let paramObj: any = JSON.parse(params[1]);
            // go through all teasers
            for (let obj of paramObj) {
                let typeID: number = obj.type;
                let textID: number = obj.tid;
                // valid teaser type?
                if (CMTCommand.TEASER_TYPE_TEXT_ID[typeID] != null) {
                    // get texts
                    let txtTitle: string = Localize.text(CMTCommand.TEASER_TYPE_TEXT_ID[typeID], [BasicModel.userData.userName]);
                    let txtCopy: string = Localize.text("cm_teaser" + textID + "_copy", [Localize.text("gametitle")]);
                    // show dialog
                    CommandController.instance.executeCommand(BasicController.COMMAND_SHOW_COMA_TEASER, [typeID, textID, txtTitle, txtCopy]);
                }
                else {
                    warn("CMTCommand - unknown teaser type: " + typeID);
                }
            }
        }
        return super.executeCommand(error, params);
    }
}
